// Beast — a seamless swirling vortex of spiral energy arms with electric-blue
// lightning flicker, mint core. The swirl is built from sin(angle*K) terms (K
// integer) so it is perfectly continuous across the -x axis — no seam line.
// Rotation is driven by raw uTime so it reads as a continuous loop; only the
// in/out envelope uses the clamped, duration-normalised time.
export const ANIMALITY_FRAG = /* glsl */ `
  precision mediump float;
  varying vec2 vUv;
  uniform float uTime;
  uniform float uDuration;
  uniform vec2 uAspect;
  uniform vec2 uCenter;

  float hash(vec2 p) {
    return fract(sin(dot(p, vec2(127.1, 311.7))) * 43758.5453);
  }

  void main() {
    vec2 uv = ((vUv - uCenter) * 2.0) * uAspect;
    float r = length(uv);
    float ang = atan(uv.y, uv.x);
    float tt = uTime;                       // raw, keeps rotating (loop feel)
    float t = clamp(uTime / uDuration, 0.0, 1.0);

    // Pulsing ring shell.
    float ringR = 0.62 + 0.05 * sin(tt * 4.0);
    float shell = exp(-11.0 * pow(r - ringR, 2.0));

    // Seamless spiral arms — sin(ang*K) is 2π-periodic for integer K, so the
    // pattern is identical at ang = +π and -π. Two layers for organic motion.
    float arm1 = 0.5 + 0.5 * sin(ang * 6.0 + tt * 5.0 - r * 9.0);
    float arm2 = 0.5 + 0.5 * sin(ang * 4.0 - tt * 3.5 + r * 6.0);
    float swirl = arm1 * arm2;

    // Lightning flicker — angular cells aligned with mod() so the seam falls on
    // a cell edge, never mid-cell.
    float cells = 12.0;
    float cell = mod(floor((ang / 6.2831853 + 0.5) * cells), cells);
    float flick = step(0.985, hash(vec2(floor(tt * 22.0), cell)));

    vec3 mint = vec3(0.063, 0.957, 0.545);
    vec3 blue = vec3(0.25, 0.65, 1.0);
    vec3 col = mix(mint, blue, swirl * 0.7) * shell * (0.55 + 1.5 * swirl);
    col += blue * flick * shell * 2.5;

    // Envelope — ramps in, holds, fades.
    float env = smoothstep(0.0, 0.22, t) * (1.0 - smoothstep(0.85, 1.0, t));

    float alpha = clamp(shell * (0.4 + swirl) + flick * shell * 1.5, 0.0, 1.0) * env;
    gl_FragColor = vec4(col, alpha);
  }
`
